(function ($) {

    $(document).ready(function () {
        let currentPageUrl = location.pathname;
        const getRecaptchaToken = () => {
            if (typeof grecaptcha === 'undefined') return;
            const prmRecaptchaSiteKey = '6LfB1GcgAAAAABEbxDEzzONlw1CM4yvv-1U3Hj91';
            grecaptcha.ready(function () {
                grecaptcha.execute(prmRecaptchaSiteKey, { action: "" })
                    .then(function (token) {
                        document.getElementById("g-recaptcha-response-prm").value = token;
                    });
            });
        }

        if (currentPageUrl.indexOf('request-for-assistance') > -1 || currentPageUrl.indexOf('zayavka-za-sadeystvie') > -1) {
            getRecaptchaToken();
            // Every 90 Seconds reset token
            setInterval(function () {
                getRecaptchaToken();
            }, 90 * 1000);           
        }

        //select restyle
        $('.prm_select').each(function () {
            let $this = $(this);
            let numberOfOptions = $(this).children('option').length;
            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            let $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());

            let $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (let i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            let $listItems = $list.children('li');

            $styledSelect.click(function (e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function () {
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
                if ($('#prm_appl_same_wrap').hasClass('rotated')) {
                    $('#prm_appl_same_wrap').removeClass('rotated');
                } else {
                    $('#prm_appl_same_wrap').addClass('rotated');
                }
            });

            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();
                if ($('#prm_appl_same_wrap').hasClass('rotated')) {
                    $('#prm_appl_same_wrap').removeClass('rotated');
                }
            });

            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
                if ($('#prm_appl_same_wrap').hasClass('rotated')) {
                    $('#prm_appl_same_wrap').removeClass('rotated');
                }
            });

        });

        if ($('#prm_form').length > 0) {

            const { __, _x, _n, _nx } = wp.i18n;

            const prmForm = $('form#prm_form');

            if (prmForm.length > 0) {

                // show/hide selects
                const prm_q4_row = $("#prm_q4_row");
                const prm_q5_row = $("#prm_q5_row");

                const prm_q3 = prmForm.find("#prm_q3_row .select-options");
                prm_q3.children('li').click(function(){
                    if( $(this).attr('rel') == 'yes') {
                        prm_q4_row.toggle();
                    } else {                        
                        prm_q4_row.hide();
                        prm_q5_row.hide();
                        prm_q4_row.find(".select-options").children('li').first().trigger('click');
                        prm_q5_row.find(".select-options").children('li').first().trigger('click');                        
                    }
                });

                const prm_q4 = prmForm.find("#prm_q4_row .select-options");
                prm_q4.children('li').click(function(){
                    if( $(this).attr('rel') == 'yes') {
                        prm_q5_row.toggle();
                    } else {
                        prm_q5_row.hide();
                        prm_q5_row.find(".select-options").children('li').first().trigger('click');
                    }
                });

                const flightDate = prmForm.find("#flight_date");
                flightDate.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: 0,
                    maxDate: "+1Y",
                    firstDay: 1
                });

                //regex for the event date
                $.validator.addMethod(
                    "eventDateFormat",
                    function (value, element, regexp) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __('Wrong date format', 'sofia-airport')
                );

                //regex for the event time
                $.validator.addMethod(
                    "regexTimeFormat",
                    function (value, element) {
                        return this.optional(element) || /^([0-9]{2}:[0-9]{2})$/i.test(value);
                    },
                    __('Wrong time format', 'sofia-airport')
                );

                //regex for the phone number
                $.validator.addMethod(
                    "phoneNumberValidation",
                    function (value, element) {
                        return this.optional(element) || /^[0-9 \+\-]{6,15}$/g.test(value);
                    },
                    __('Wrong phone number format', 'sofia-airport')
                );

                //regex for the address
                $.validator.addMethod(
                    "addressValidation",
                    function (value, element) {
                        return this.optional(element) || /^[a-zA-zа-яА-ЯёЁ0-9\'\,\„\“\s\*\)\(\+\=\.\_\-\"\"\№\#]+$/gi.test(value);
                    },
                    __('Please remove the special symbols', 'sofia-airport')
                );

                //regex for the text
                $.validator.addMethod(
                    "textValidation",
                    function (value, element) {
                        return this.optional(element) || /^[a-zA-zа-яА-ЯёЁ0-9\'\,\„\“\s\*\)\(\+\=\.\_\-\"\"\№\#]+$/gi.test(value);
                    },
                    __('Please remove the special symbols', 'sofia-airport')
                );

                //method for the select dropdown
                $.validator.addMethod(
                    "valueNotEquals",
                    function (value, element, arg) {
                        return arg !== value;
                    },
                    __('The field is required', 'sofia-airport')
                );

                //regex the flight number
                $.validator.addMethod(
                    "regexFlightNo",
                    function (value, element) {
                        return this.optional(element) || /^([a-zA-Z]+[a-zA-Z0-9]+)$/i.test(value);
                    },
                    __('Wrong flight number', 'sofia-airport')
                );

                prmForm.validate({
                    rules: {
                        appl_name: {
                            textValidation: true,
                            required: true
                        },
                        appl_phone_number: {
                            phoneNumberValidation: true,
                            required: false
                        },
                        appl_address: {
                            addressValidation: true,
                            required: false
                        },
                        appl_city: {
                            addressValidation: true,
                            required: false
                        },
                        appl_email: {
                            email: true,
                            required: true
                        },
                        prm_appl_same: {
                            required: true
                        },
                        prm_q1: {
                            required: true
                        },
                        prm_q2: {
                            required: true
                        },
                        prm_q3: {
                            valueNotEquals: "hide",
                            required: true
                        },
                        prm_q4: {
                            required: true
                        },
                        prm_q5: {
                            required: true
                        },
                        prm_q6: {
                            required: true
                        },
                        first_name: {
                            textValidation: true,
                            required: true
                        },
                        last_name: {
                            textValidation: true,
                            required: true
                        },
                        pass_phone_number: {
                            phoneNumberValidation: true,
                            required: false
                        },
                        limitations: {
                            textValidation: true,
                            required: false
                        },
                        flight_date: {
                            required: true,
                            eventDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        },
                        flight_time: {
                            required: true,
                            regexTimeFormat: true
                        },
                        flight_no: {
                            required: true,
                            minlength: 5,
                            maxlength: 7,
                            regexFlightNo: true
                        },
                        destination: {
                            textValidation: true,
                            required: true,
                        },
                        remarks: {
                            textValidation: true,
                            required: false
                        },
                    },
                    submitHandler: function (form) {
                        let prmRequestData = {
                            'prmWebsite': $('input[name=website]').val(),
                            'applName': $('input[name=appl_name]').val(),
                            'applPhone': $('input[name=appl_phone_number]').val(),
                            'applAddress': $('input[name=appl_address]').val(),
                            'applCity': $('input[name=appl_city]').val(),
                            'applEmail': $('input[name=appl_email]').val(),
                            'applSame': $('#prm_appl_same').find(":selected").text(),
                            'prmFirstName': $('input[name=first_name]').val(),
                            'prmLastName': $('input[name=last_name]').val(),
                            'prmGender': $('#prm_gender').find(":selected").text(),
                            'prmPhone': $('input[name=pass_phone_number]').val(),
                            'prmQ1': $('#prm_q1').find(":selected").text(),
                            'prmQ2': $('#prm_q2').find(":selected").text(),
                            'prmQ3': $('#prm_q3').find(":selected").text(),
                            'prmQ4': $('#prm_q4').find(":selected").text(),
                            'prmQ5': $('#prm_q5').find(":selected").text(),
                            'prmQ6': $('#prm_q6').find(":selected").text(),
                            'prmLimitations': $('textarea[name=limitations]').val(),
                            'prmFlightDate': $('input[name=flight_date]').val(),
                            'prmFlightTime': $('input[name=flight_time]').val(),
                            'prmFlightNo': $('input[name=flight_no]').val(),
                            'prmDestination': $('input[name=destination]').val(),
                            'prmRemarks': $('textarea[name=remarks]').val(),
                        };

                        let prmRecaptchaResponse = $('#g-recaptcha-response-prm').val();

                        //send search request
                        prmRequestData = JSON.parse(JSON.stringify(prmRequestData));

                        $.ajax({
                            type: "POST",
                            url: "/wp-admin/admin-ajax.php",
                            dataType: "JSON",
                            data: {
                                action: "prm_form",
                                data: prmRequestData,
                                prmRecaptchaResponseData: prmRecaptchaResponse,

                            },
                            success: function (resp) {
                                // This outputs the result of the ajax request
                                if (resp.success == false) {
                                    $('#responseBox').text(resp.data);
                                } else {
                                    $('#responseBox').text(resp.data);
                                    form.reset();
                                }
                                getRecaptchaToken();
                            },
                            error: function (errorThrown) {
                                //Returns the thrown error
                                getRecaptchaToken();
                            }
                        });
                    }
                });

                $.extend($.validator.messages, {
                    required: __('The field is required', 'sofia-airport'),
                    email: __('Please enter a valid email address', 'sofia-airport'),
                });
            }
        }
    });
})(jQuery);